import { TrophyIcon } from '@heroicons/react/20/solid'
import { Button, Card } from '@radix-ui/themes'
import React, { useEffect, useRef } from 'react'
import { toCapitalizeFirst } from '#app/utils/textHelpers.ts'

type Props = {
	raceCount: number
	resultCount: number
	mostRecentRaceDate: string
}

export default function Summary(props: Props) {
	return (
		<Card className="w-full">
			<div className="text-h5">2024 Statistics</div>
			<div className="flex justify-around">
				<CountingCard count={props.raceCount} title="Races" />
				<CountingCard count={props.resultCount} title="Results" />
			</div>
		</Card>
	)
}

type CountingCardProps = {
	count: number
	title: string
}

const CountingCard = (props: CountingCardProps) => {
	// const ref = useRef<HTMLDivElement>(null)
	// const countRef = useRef<number>(0)

	// useEffect(() => {
	// 	if (ref.current) {
	// 		ref.current.innerHTML = 0
	// 	}
	// }, [ref])

	return (
		<div className="flex flex-col items-center font-mono">
			<div className="text-[2rem] text-yellow-500">{Number(props.count).toLocaleString()}</div>
			<div>{props.title}</div>
		</div>
	)
}
